import React, { useState, useEffect, useCallback } from 'react';
const API = process.env.REACT_APP_API_URL || 'https://tcio-api.onrender.com';
const token = () => localStorage.getItem('tcio_token');
const jh = () => ({ Authorization: `Bearer ${token()}`, 'Content-Type': 'application/json' });

const PAGES = ['Dashboard','Queue','Calls','Leads','Bed Board','UR','Prescreen','Ready to Bill','Collections','Money','Reports','AR','Compliance','Other'];
const URGENCY_COLOR = { urgent: '#ef4444', normal: '#f59e0b', low: '#64748b' };
const STATUS_META = {
  open:        { label: 'Open',        bg: '#fef3c7', fg: '#92400e' },
  in_progress: { label: 'In Progress', bg: '#dbeafe', fg: '#1e40af' },
  fixed:       { label: 'Fixed',       bg: '#dcfce7', fg: '#166534' },
};

const st = {
  page: { padding: '24px', maxWidth: '1100px', margin: '0 auto' },
  h1: { fontSize: '22px', fontWeight: 700, color: '#1e293b', margin: '0 0 16px' },
  filters: { display: 'flex', gap: '8px', marginBottom: '16px' },
  fBtn: (on) => ({ padding: '6px 14px', borderRadius: '16px', border: '1px solid #cbd5e1', background: on ? '#1e293b' : '#fff', color: on ? '#fff' : '#334155', fontSize: '13px', fontWeight: 600, cursor: 'pointer' }),
  card: { background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '14px 16px', marginBottom: '10px' },
  row: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px' },
  title: { fontSize: '15px', fontWeight: 700, color: '#1e293b' },
  meta: { fontSize: '12px', color: '#64748b', marginTop: '2px' },
  desc: { fontSize: '13px', color: '#334155', marginTop: '8px', whiteSpace: 'pre-wrap' },
  chip: (m) => ({ fontSize: '11px', fontWeight: 700, padding: '3px 10px', borderRadius: '12px', background: m.bg, color: m.fg, whiteSpace: 'nowrap' }),
  urg: (u) => ({ fontSize: '11px', fontWeight: 700, color: URGENCY_COLOR[u] || '#64748b', textTransform: 'uppercase' }),
  btn: { padding: '6px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', background: '#fff', fontSize: '12px', fontWeight: 600, cursor: 'pointer', color: '#334155' },
  btnGreen: { padding: '6px 12px', borderRadius: '6px', border: 'none', background: '#16a34a', color: '#fff', fontSize: '12px', fontWeight: 600, cursor: 'pointer' },
  note: { fontSize: '13px', color: '#166534', background: '#f0fdf4', borderRadius: '6px', padding: '8px 10px', marginTop: '8px' },
  input: { width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '13px', boxSizing: 'border-box' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modal: { background: '#fff', borderRadius: '12px', padding: '20px', width: '440px', maxWidth: '92vw', maxHeight: '85vh', overflowY: 'auto' },
  label: { fontSize: '12px', fontWeight: 700, color: '#475569', margin: '10px 0 4px', display: 'block' },
  drop: (over) => ({ border: `2px dashed ${over ? '#2563eb' : '#cbd5e1'}`, borderRadius: '8px', padding: '16px', textAlign: 'center', fontSize: '13px', color: '#64748b', background: over ? '#eff6ff' : '#f8fafc', cursor: 'pointer' }),
  fab: { position: 'fixed', bottom: '20px', right: '20px', zIndex: 900, background: '#1e293b', color: '#fff', border: 'none', borderRadius: '24px', padding: '10px 18px', fontSize: '13px', fontWeight: 700, cursor: 'pointer', boxShadow: '0 4px 14px rgba(0,0,0,0.25)', display: 'flex', alignItems: 'center', gap: '8px' },
  fabDot: { background: '#22c55e', borderRadius: '50%', width: '10px', height: '10px' },
};

function CommentThread({ ticketId }) {
  const [open, setOpen] = useState(false);
  const [comments, setComments] = useState([]);
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);

  const loadComments = async () => {
    try {
      const r = await fetch(`${API}/api/tickets/${ticketId}/comments`, { headers: jh() });
      const j = await r.json();
      if (j.ok) setComments(j.comments);
    } catch (e) { console.error(e); }
  };

  const toggle = () => {
    const next = !open;
    setOpen(next);
    if (next) loadComments();
  };

  const post = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      const r = await fetch(`${API}/api/tickets/${ticketId}/comments`, {
        method: 'POST', headers: jh(), body: JSON.stringify({ comment_text: text }),
      });
      const j = await r.json();
      if (j.ok) { setText(''); loadComments(); }
      else alert(j.error || 'Comment failed');
    } catch (e) { alert('Comment failed'); }
    setBusy(false);
  };

  return (
    <div style={{ marginTop: '8px' }}>
      <button onClick={toggle}
        style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: '12px', color: '#475569', padding: 0, fontWeight: 600 }}>
        💬 {open ? 'Hide comments' : 'Comments'}
      </button>
      {open && (
        <div style={{ marginTop: '6px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
          {comments.length === 0 && <div style={{ fontSize: '12px', color: '#94a3b8' }}>No comments yet.</div>}
          {comments.map(c => (
            <div key={c.id} style={{ fontSize: '12px', background: '#f8fafc', borderRadius: '6px', padding: '6px 8px' }}>
              <span style={{ fontWeight: 600 }}>{c.commenter_name || 'Staff'}</span>
              <span style={{ color: '#94a3b8' }}>
                {' · '}{new Date(c.created_at).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}
              </span>
              <div style={{ marginTop: '2px', whiteSpace: 'pre-wrap' }}>{c.comment_text}</div>
            </div>
          ))}
          <div style={{ display: 'flex', gap: '6px' }}>
            <input value={text} placeholder="Add a comment…"
              onChange={e => setText(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') post(); }}
              style={{ flex: 1, padding: '6px 8px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '12px' }} />
            <button onClick={post} disabled={busy}
              style={{ padding: '6px 12px', borderRadius: '6px', border: 'none', background: '#166534', color: '#fff', fontSize: '12px', cursor: 'pointer', opacity: busy ? 0.6 : 1 }}>
              {busy ? '…' : 'Post'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Floating button + filing modal + "my tickets" — rendered for EVERYONE from App.js
export function ReportIssue({ user }) {
  const [open, setOpen] = useState(false);
  const [mine, setMine] = useState([]);
  const [greenDot, setGreenDot] = useState(false);
  const [form, setForm] = useState({ title: '', description: '', page: 'Other', urgency: 'normal' });
  const [editing, setEditing] = useState(null);   // id of the filer's own ticket being edited (11/1)
  const blankForm = () => setForm({ title: '', description: '', page: 'Other', urgency: 'normal' });
  const [file, setFile] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const loadBadge = useCallback(async () => {
    try {
      const r = await fetch(`${API}/api/tickets/badge`, { headers: jh() });
      const j = await r.json();
      if (j.ok) setGreenDot(j.my_fixed_unseen > 0);
    } catch (e) {}
  }, []);
  useEffect(() => { loadBadge(); const t = setInterval(loadBadge, 120000); return () => clearInterval(t); }, [loadBadge]);

  const removeMine = async (tk) => {
    if (!window.confirm('Delete this ticket? "' + tk.title + '" will be removed and nobody will work on it.')) return;
    try {
      const r = await fetch(`${API}/api/tickets/${tk.id}`, { method: 'DELETE', headers: jh() });
      const j = await r.json();
      if (j.ok) setMine(m => m.filter(x => x.id !== tk.id));
      else window.alert(j.error || 'Could not delete the ticket');
    } catch (err) { window.alert('Could not delete the ticket'); }
  };

  const openPanel = async () => {
    setOpen(true); setMsg(null);
    try {
      const r = await fetch(`${API}/api/tickets/mine`, { headers: jh() });
      const j = await r.json();
      if (j.ok) { setMine(j.tickets); setGreenDot(false); }
    } catch (e) {}
  };

  const submit = async () => {
    if (!form.title.trim()) { setMsg({ t: 'err', x: 'Give it a short title.' }); return; }
    setBusy(true); setMsg(null);
    if (editing) {
      try {
        const r = await fetch(`${API}/api/tickets/${editing}/edit`, { method: 'PATCH', headers: { ...jh(), 'Content-Type': 'application/json' },
          body: JSON.stringify({ title: form.title.trim(), description: form.description.trim(), page: form.page, urgency: form.urgency }) });
        const j = await r.json();
        if (j.ok) { setMsg({ t: 'ok', x: '\u2713 Ticket updated.' }); setMine(m => m.map(x => x.id === editing ? { ...x, ...j.ticket } : x)); setEditing(null); blankForm(); }
        else setMsg({ t: 'err', x: j.error || 'Failed' });
      } catch (e) { setMsg({ t: 'err', x: 'Network error' }); }
      setBusy(false); return;
    }
    try {
      const fd = new FormData();
      fd.append('title', form.title.trim());
      fd.append('description', form.description.trim());
      fd.append('page', form.page);
      fd.append('urgency', form.urgency);
      if (file) fd.append('screenshot', file);
      const r = await fetch(`${API}/api/tickets`, { method: 'POST', headers: { Authorization: `Bearer ${token()}` }, body: fd });
      const j = await r.json();
      if (j.ok) {
        setMsg({ t: 'ok', x: '✓ Ticket filed — Chad will see it.' });
        setForm({ title: '', description: '', page: 'Other', urgency: 'normal' });
        setFile(null);
        const r2 = await fetch(`${API}/api/tickets/mine`, { headers: jh() });
        const j2 = await r2.json();
        if (j2.ok) setMine(j2.tickets);
      } else setMsg({ t: 'err', x: j.error || 'Failed' });
    } catch (e) { setMsg({ t: 'err', x: 'Network error' }); }
    setBusy(false);
  };

  const onDrop = (e) => {
    e.preventDefault(); setDragOver(false);
    const f = e.dataTransfer.files && e.dataTransfer.files[0];
    if (f && /^image\//.test(f.type)) setFile(f);
  };

  return (
    <>
      <button style={st.fab} onClick={openPanel} title="Report a problem or request">
        {greenDot && <span style={st.fabDot} />} Report Issue
      </button>
      {open && (
        <div style={st.overlay} onClick={() => setOpen(false)}>
          <div style={st.modal} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ fontSize: '17px', fontWeight: 700 }}>Report an Issue</div>
              <button style={st.btn} onClick={() => setOpen(false)}>Close</button>
            </div>

            <label style={st.label}>What's wrong? *</label>
            {editing && <div style={{ fontSize: '12px', color: '#0878E8', marginBottom: '6px' }}>Editing your ticket. Change it below and press the button to save. <span role="button" style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => { setEditing(null); blankForm(); setMsg(null); }}>Cancel edit</span></div>}
            <input style={st.input} value={form.title} maxLength={200} placeholder="e.g. Discharge date showing wrong"
              onChange={e => setForm({ ...form, title: e.target.value })} />

            <label style={st.label}>Details</label>
            <textarea style={{ ...st.input, minHeight: '70px' }} value={form.description}
              placeholder="What happened, what you expected, patient/record name if relevant"
              onChange={e => setForm({ ...form, description: e.target.value })} />

            <div style={{ display: 'flex', gap: '10px' }}>
              <div style={{ flex: 1 }}>
                <label style={st.label}>Page</label>
                <select style={st.input} value={form.page} onChange={e => setForm({ ...form, page: e.target.value })}>
                  {PAGES.map(p => <option key={p}>{p}</option>)}
                </select>
              </div>
              <div style={{ flex: 1 }}>
                <label style={st.label}>Urgency</label>
                <select style={st.input} value={form.urgency} onChange={e => setForm({ ...form, urgency: e.target.value })}>
                  <option value="low">Low</option>
                  <option value="normal">Normal</option>
                  <option value="urgent">Urgent</option>
                </select>
              </div>
            </div>

            <label style={st.label}>Screenshot (optional)</label>
            <div style={st.drop(dragOver)}
              onDragOver={e => { e.preventDefault(); setDragOver(true); }}
              onDragLeave={() => setDragOver(false)}
              onDrop={onDrop}
              onClick={() => document.getElementById('tkt-file').click()}>
              {file ? `📎 ${file.name}` : 'Drag & drop an image here, or click to choose'}
            </div>
            <input id="tkt-file" type="file" accept="image/*" style={{ display: 'none' }}
              onChange={e => setFile(e.target.files[0] || null)} />

            {msg && <div style={{ marginTop: '10px', fontSize: '13px', fontWeight: 600, color: msg.t === 'ok' ? '#16a34a' : '#ef4444' }}>{msg.x}</div>}
            <button style={{ ...st.btnGreen, width: '100%', marginTop: '12px', padding: '10px', opacity: busy ? 0.6 : 1 }} disabled={busy} onClick={submit}>
              {busy ? 'Filing…' : 'File Ticket'}
            </button>

            {mine.length > 0 && (
              <>
                <div style={{ fontSize: '14px', fontWeight: 700, margin: '18px 0 8px' }}>My Tickets</div>
                {mine.map(t => (
                  <div key={t.id} style={{ ...st.card, padding: '10px 12px' }}>
                    <div style={st.row}>
                      <div style={{ fontSize: '13px', fontWeight: 600 }}>{t.title}</div>
                      <span style={st.chip(STATUS_META[t.status] || STATUS_META.open)}>{(STATUS_META[t.status] || STATUS_META.open).label}</span>
                    </div>
                    {t.status === 'fixed' && t.resolution_note && <div style={st.note}>✓ {t.resolution_note}</div>}
                    <CommentThread ticketId={t.id} />
                    {t.status !== 'fixed' && <div style={{ textAlign: 'right', marginTop: '6px' }}>
                      <button style={{ ...st.btn, marginRight: '6px' }} onClick={() => { setEditing(t.id); setForm({ title: t.title || '', description: t.description || '', page: t.page || 'Other', urgency: t.urgency || 'normal' }); setMsg({ t: 'ok', x: 'Editing "' + t.title + '" \u2014 it is loaded in the form above.' }); }}>Edit ticket</button>
                      <button style={{ ...st.btn, color: '#b91c1c', borderColor: '#fecaca' }} onClick={() => removeMine(t)}>Delete ticket</button></div>}
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

// ── Full Tickets page (ceo/admin; UR-scoped for ur_supervisor via API)
export default function Tickets({ user }) {
  const [tickets, setTickets] = useState([]);
  const [filter, setFilter] = useState('active');
  const [loading, setLoading] = useState(true);
  const [noteFor, setNoteFor] = useState(null);
  const [note, setNote] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}/api/tickets`, { headers: jh() });
      const j = await r.json();
      if (j.ok) setTickets(j.tickets);
    } catch (e) {}
    setLoading(false);
  }, []);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (id, status, resolution_note) => {
    await fetch(`${API}/api/tickets/${id}`, { method: 'PATCH', headers: jh(), body: JSON.stringify({ status, resolution_note }) });
    setNoteFor(null); setNote('');
    load();
  };

  const viewShot = async (id) => {
    const r = await fetch(`${API}/api/tickets/${id}/screenshot`, { headers: jh() });
    const j = await r.json();
    if (j.ok) window.open(j.url, '_blank');
  };

  const shown = tickets.filter(t => filter === 'all' ? true : filter === 'active' ? t.status !== 'fixed' : t.status === filter);

  return (
    <div style={st.page}>
      <h1 style={st.h1}>Tickets</h1>
      <div style={st.filters}>
        {[['active','Active'],['fixed','Fixed'],['all','All']].map(([k, l]) => (
          <button key={k} style={st.fBtn(filter === k)} onClick={() => setFilter(k)}>{l}</button>
        ))}
      </div>
      {loading ? <div>Loading…</div> : shown.length === 0 ? <div style={{ color: '#64748b' }}>No tickets here.</div> :
        shown.map(t => (
          <div key={t.id} style={st.card}>
            <div style={st.row}>
              <div>
                <div style={st.title}>{t.title}</div>
                <div style={st.meta}>
                  <span style={st.urg(t.urgency)}>{t.urgency}</span>
                  {' · '}{t.creator_name} ({t.creator_role}){' · '}{t.page || 'Other'}{' · '}
                  {new Date(t.created_at).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}
                </div>
              </div>
              <span style={st.chip(STATUS_META[t.status] || STATUS_META.open)}>{(STATUS_META[t.status] || STATUS_META.open).label}</span>
            </div>
            {t.description && <div style={st.desc}>{t.description}</div>}
            {t.resolution_note && <div style={st.note}>✓ {t.resolution_note} — {t.resolved_by}</div>}
            <div style={{ display: 'flex', gap: '8px', marginTop: '10px' }}>
              {t.screenshot_key && <button style={st.btn} onClick={() => viewShot(t.id)}>📎 Screenshot</button>}
              {['ceo','admin'].includes(user.role) && t.status === 'open' && (
                <button style={st.btn} onClick={() => setStatus(t.id, 'in_progress')}>Start</button>
              )}
              {['ceo','admin'].includes(user.role) && t.status !== 'fixed' && (
                noteFor === t.id ? (
                  <>
                    <input style={{ ...st.input, width: '260px' }} autoFocus value={note} placeholder="What was done (they'll see this)"
                      onChange={e => setNote(e.target.value)} />
                    <button style={st.btnGreen} onClick={() => setStatus(t.id, 'fixed', note)}>Confirm Fixed</button>
                    <button style={st.btn} onClick={() => { setNoteFor(null); setNote(''); }}>Cancel</button>
                  </>
                ) : (
                  <button style={st.btnGreen} onClick={() => setNoteFor(t.id)}>Mark Fixed</button>
                )
              )}
            </div>
            <CommentThread ticketId={t.id} />
          </div>
        ))}
    </div>
  );
}
